import { css } from 'styled-components';
import { COLORS } from '../../design/tokens';

const styles = {
  container: css`
    height: 100px;
    position: relative;
  `,
  tagContainer: css`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 40px;
    width: 186px;
    background-color: ${COLORS.TAG.BACKGROUND};
    right: -33px;

    &::after {
      position: absolute;
      content: '';
      height: 40px;
      left: -15px;
      border-right: 15px solid ${COLORS.TAG.BACKGROUND};
      border-bottom: 20px solid transparent;
      border-top: 20px solid transparent;
    }
  `,
  tagLabel: css`
    color: ${COLORS.TAG.TEXT};
    font-size: 16px;
    line-height: 26px;
  `
};

export default styles;
